import styled from 'styled-components';
import { prefix } from '../../tools/settings';
import Icon from '../Icon';
var Accordion = styled.ul.withConfig({
  displayName: "Accordionstyles__Accordion",
  componentId: "sc-99v26x-0"
})(["background:transparent;margin:0;padding:0;list-style-type:none;border-top:1px solid var(--dentsu-color-n300);& &{border-top:0;margin-top:-0.75rem;}"]);
var AccordionItem = styled.li.withConfig({
  displayName: "Accordionstyles__AccordionItem",
  componentId: "sc-99v26x-1"
})(["margin:0;padding:0;& &{margin-left:var(--dentsu-spacing-32);}"]);
var AccordionHeader = styled.div.withConfig({
  displayName: "Accordionstyles__AccordionHeader",
  componentId: "sc-99v26x-2"
})(["display:flex;align-items:center;margin:0;width:100%;border-bottom:1px solid var(--dentsu-color-n300);.", "-accordion-header-checkbox{margin-right:var(--dentsu-spacing-8);label.bp3-checkbox{display:block;margin-right:0;}}"], prefix);
var AccordionTitle = styled.div.withConfig({
  displayName: "Accordionstyles__AccordionTitle",
  componentId: "sc-99v26x-3"
})(["display:flex;align-items:center;justify-content:space-between;flex:1;padding:var(--dentsu-spacing-12) 0;text-align:left;font-size:var(--dentsu-font-size-20);font-weight:var(--dentsu-font-weight-bold);color:var(--dentsu-color-n1000);opacity:", ";"], function (props) {
  return props.isDisabled ? 0.4 : 1;
});
var ToggleIcon = styled(Icon).withConfig({
  displayName: "Accordionstyles__ToggleIcon",
  componentId: "sc-99v26x-4"
})(["margin:var(--dentsu-spacing-8) var(--dentsu-spacing-12);color:var(--dentsu-color-n600);"]);
var AccordionContent = styled.div.withConfig({
  displayName: "Accordionstyles__AccordionContent",
  componentId: "sc-99v26x-5"
})(["background:transparent;margin:0;padding:0;.", "-collapsible__content[aria-hidden='false']{padding-top:", ";padding-right:", ";padding-bottom:", ";padding-left:", ";}"], prefix, function (props) {
  var _props$pt;

  return (_props$pt = props.pt) !== null && _props$pt !== void 0 ? _props$pt : 'var(--dentsu-spacing-12)';
}, function (props) {
  var _props$pr;

  return (_props$pr = props.pr) !== null && _props$pr !== void 0 ? _props$pr : 0;
}, function (props) {
  var _props$pb;

  return (_props$pb = props.pb) !== null && _props$pb !== void 0 ? _props$pb : 'var(--dentsu-spacing-12)';
}, function (props) {
  var _props$pl;

  return (_props$pl = props.pl) !== null && _props$pl !== void 0 ? _props$pl : 0;
});
export var Styled = {
  Accordion: Accordion,
  AccordionItem: AccordionItem,
  AccordionHeader: AccordionHeader,
  AccordionTitle: AccordionTitle,
  AccordionContent: AccordionContent,
  ToggleIcon: ToggleIcon
};